import React from 'react';
import styled, { css } from 'styled-components';
import propTypes from 'prop-types';
import breakpointsMinWidth from '../../../../../../cra/src/styling/breakpointsMinWidth';
import LinkLogo from './linkLogo';

const LogoWrapper = styled.li`
  float: left;

  ${(props) => {
    const { pathname } = props;

    if (pathname.includes('/documents/')) {
      return css`
        display: flex;
        align-items: center;
        justify-self: center;
        height: inherit;
        padding-right: 12px;
        height: inherit;
      `;
    }

    if (pathname !== '/') {
      return css`
        grid-column: 2;
      `;
    }

    return null;
  }}

  .wisedoc {
    width: 116px;

    @media ${breakpointsMinWidth.mobileMd} {
      width: 124px;
    }

    @media ${breakpointsMinWidth.tabletSm} {
      width: 104px;
    }

    @media ${breakpointsMinWidth.tabletLg} {
      width: 120px;
    }
    @media ${breakpointsMinWidth.desktopMd} {
      width: 140px;
    }
  }
`;

export const WisedocLogo2 = ({ width }) => (
  <img src="/assets/logo.png" alt="Wisedoc Logo" width={width} />
);

const Logo = (props) => {
  const { pathname } = props;

  return (
    <LogoWrapper pathname={pathname} data-testid="logo-wrapper">
      <LinkLogo {...props} />
    </LogoWrapper>
  );
};

Logo.propTypes = {
  pathname: propTypes.string.isRequired,
  isTop: propTypes.bool.isRequired,
};

export default React.memo(Logo);
